import * as type from "../actions/types";

const initialState = {
  errors: [],
  loading: false,
  success: false,
  data: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case type.FETCH_SELF_PENDING:
      return {
        ...state,
        ...initialState,
        loading: true,
        success: false,
        errors: [],
      };
    case type.FETCH_SELF_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        errors: [],
        data: action.payload,
      };
    case type.FETCH_SELF_FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        errors: action.payload,
      };
    default:
      return state;
  }
};
